import { Component, OnInit, Input, OnChanges } from '@angular/core';
import { Subject } from '../shared/model/subject.model';
import { MatTableDataSource, MatDialog, MatDialogConfig, MatSnackBar, MatSnackBarConfig } from '@angular/material';
import { College } from '../shared/model/college.model';
import {Observable} from 'rxjs';
import {map, startWith} from 'rxjs/operators';
import { FormControl, Validators } from '@angular/forms';
import { SelectCollageDialogComponent } from 'src/app/core/modal/select-collage-dialog/select-collage-dialog.component';
import { SnackbarMessageComponent } from 'src/app/core/snackbar-message/snackbar-message.component';

@Component({
  selector: 'app-subjects',
  templateUrl: './subjects.component.html',
  styleUrls: ['./subjects.component.scss']
})
export class SubjectsComponent implements OnInit, OnChanges {

  displayedColumns = ['materia', 'institucion', 'programa', 'periodo', 'creditos', 'calificacion', 'comentario', 'actionsColumn' ];
  dataSource;
  unamePattern = '^[3-5]+([,][0-9]+)?$';
  creditosPattern = '^(0?[1-9]|[1-9][0-9])$';
  subjects: Subject[] = [];
  @Input() colleges: College[];
  @Input() periodStudent: String[];
  options: string[] = ['One', 'Two', 'Three'];
  periodControl = new FormControl();
  nameControl = new FormControl('', [Validators.required]);
  filteredOptions: Observable<String[]>;
  periods: String[] = [];

  constructor(private dialog: MatDialog, private snackBar: MatSnackBar ) { }

  ngOnInit() {
    this.insertSubject();
    this.generatePeriod();
  }

  ngOnChanges() {
    this.filteredOptions = this.periodControl.valueChanges
      .pipe(
        startWith(''),
        map(value => this._filter(value))
      );
  }

  clean() {
    this.subjects = [];
    this.insertSubject();
  }

  deleteSubject(item) {
    this.subjects.splice(item, 1);
    this.dataSource = new MatTableDataSource(this.subjects);
  }

  insertSubject() {
    const subject = new Subject();
    subject.periodo = this.getCurrentPeriodoAvaible();
    this.subjects.push(subject);
    this.dataSource = new MatTableDataSource(this.subjects);
  }

  openDialog(subject) {
    const index =  this.dataSource.filteredData.indexOf(subject);
    const dialogConfig = new MatDialogConfig();
    dialogConfig.data =  { collages: this.colleges, index: index};
    dialogConfig.width = '70%';
    const dialogRef = this.dialog.open(SelectCollageDialogComponent, dialogConfig);
    dialogRef.afterClosed().subscribe(value => {
        if (value !== null) {
          this.subjects[value.index].institucion = value.college.codigo;
        }
    });
  }

  openSnackBar(message, index, oldValue) {
    const snackBarConfig = new MatSnackBarConfig();
    snackBarConfig.data =  { message: message };
    snackBarConfig.duration = 1500;
    const dd = this.snackBar.openFromComponent(SnackbarMessageComponent, snackBarConfig);
    dd.afterDismissed().subscribe(
      (result) => {
        this.subjects[index].periodo = oldValue;
        this.dataSource =  new MatTableDataSource(this.subjects);

      }
    );
  }

  validatePeriod(event, element) {
    const index =  this.dataSource.filteredData.indexOf(element);
    const oldValue = this.subjects[index].periodo;
    console.log(oldValue);
    if (this.validatePeriodStudent(event)) {
      const message = 'No es posible seleccionar el semestre ' + event + ' porque usted estaba activo en la UdeA para dicho semestre';
      this.openSnackBar(message, index, oldValue);
    }
  }

  private validatePeriodStudent(period): boolean {
    let result = false;
    if (period !== undefined) {
      const periodFormat = period.replace('-', '');
      const findIndex = this.periodStudent.findIndex(  element =>  element === periodFormat);
      if (findIndex !== -1) {
        result = true;
      }
    }
    return result;
  }

  private getCurrentPeriodoAvaible(): String {
    const currentYear = (new Date()).getFullYear();
    const currentMonth = (new Date()).getMonth();
    let periodAvaible ;

    if (currentMonth >= 6) {
      periodAvaible = currentYear + '-' + 1;
    } else {
      periodAvaible = (currentYear - 1) + '-' +  2;
    }
    return periodAvaible;
  }

  private generatePeriod() {
    const currentYear = (new Date()).getFullYear();
    const currentMonth = (new Date()).getMonth();
    if (currentMonth >= 6) {
      this.periods.push(this.getCurrentPeriodoAvaible());
    }

    for (let i = currentYear - 1; i >= (currentYear - 50 ); i--) {
      this.periods.push(i + '-2');
      this.periods.push(i + '-1');
    }
  }

  private _filter(value: string): String[] {
    if (this.periods === undefined) {
      return this.periods;
    } else {
      if (value === undefined) {
        return this.periods;
      } else {
        const filterValue = value.toLowerCase();
        if (filterValue === '') {
          return this.periods;
        }
        return this.periods.filter(option => option.toLowerCase().includes(filterValue));
      }
    }
  }
}
